<template>
	<div class="message-box dialog-mask">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header"><h4 class="modal-title" v-t="{ path: title }"></h4></div>
				<div class="modal-body">
					<p
						v-html="$t(errorMessageId, { errorCode: errorCode, lineBreak: '<br />' })"
					></p>
					<i18n v-if="showSupport" path="error.try_again_or_support" tag="p">
						<a
							place="support"
							href="https://support.nexon.net/hc/en-us/"
							target="_blank"
							rel="external"
							>{{ $t('support') }}</a
						>
					</i18n>
				</div>
				<div class="modal-footer">
					<div class="col-xs-6 pull-right">
						<FormButton
							id="modalPrimaryButtonId"
							class="btn-black"
							:buttonClick="click"
							:label="$t(closeLabel)"
						>
						</FormButton>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { FormButton } from '@arena/toolkit';

export default {
	components: {
		FormButton,
	},
	props: {
		title: {
			type: String,
			default: 'dialog.title.error',
		},
		errorCode: {
			type: String,
			default: '00000',
		},
		closeLabel: {
			type: String,
			default: 'close',
		},
	},
	computed: {
		errorMessageId() {
			const msgId = `error.form.${this.errorCode}`;
			if (msgId === this.$t(msgId)) {
				return 'error.form.GENERAL';
			}
			return msgId;
		},
		showSupport() {
			return this.errorMessageId === 'error.form.GENERAL';
		},
	},
	methods: {
		click() {
			this.$close(true);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/common/dialogs/error.vue